"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.services = exports.machineJSON = exports.guards = exports.delays = exports.default = exports.actions = void 0;
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));
var _xstate = require("xstate");
var _api = require("../api");
var _states = require("../constants/states");
var _actions = require("../constants/actions");
var _getInitialContext = _interopRequireDefault(require("./getInitialContext"));
// exporting actions, delays, guards, and services to enable testing

const actions = exports.actions = {
  setAvailByLocId: (0, _xstate.assign)({
    availByLocId: (ctx, ev) => {
      var _context, _context2;
      // get all locations
      const availByLocId = (0, _reduce.default)(_context = ctx.locations).call(_context, (acc, loc) => {
        acc[loc.id] = [];
        return acc;
      }, {});

      // push to each location accordingly
      (0, _forEach.default)(_context2 = ev.data).call(_context2, availability => {
        availByLocId[availability.location_id].push(availability);
      });
      return availByLocId;
    }
  }),
  willRetry: (0, _xstate.assign)({
    retries: ctx => ctx.retries + 1
  }),
  setApptInfo: (0, _xstate.assign)({
    apptInfo: (ctx, ev) => ev.data
  })
};
const delays = exports.delays = {
  // exponential backoff
  // https://dzone.com/articles/understanding-retry-pattern-with-exponential-back
  backoff: ctx => ctx.retries * ctx.retryDelayMs
};
const guards = exports.guards = {
  canLoadAvail: (ctx, ev) => ev.data && ev.data.purpose && ev.data.relationship && ctx.canBookOnline,
  shouldRetry: ctx => {
    return ctx.retries < ctx.maxRetries;
  }
};
const services = exports.services = {
  getAvailability: _ref => {
    let {
      customerCode,
      apptInfo,
      locations,
      provider,
      role,
      visibility
    } = _ref;
    return (0, _api.getNextAvailabilityList)({
      params: {
        customerCode,
        location_ids: (0, _map.default)(locations).call(locations, loc => loc.id),
        provider,
        purpose: apptInfo.purpose,
        patient_relationship: apptInfo.relationship,
        period_start: (0, _now.default)(),
        role,
        visibility
      }
    });
  }
};

// exporting machineJSON to enable snapshot testing
const machineJSON = _ref2 => {
  let {
    customerCode,
    canBookOnline,
    locations,
    provider
  } = _ref2;
  return {
    initial: _states.idle,
    context: {
      ...(0, _getInitialContext.default)(),
      customerCode,
      canBookOnline,
      locations,
      provider
    },
    on: {
      [_actions.SET_APPT_INFO]: [{
        actions: 'setApptInfo',
        target: _states.pending,
        cond: 'canLoadAvail'
      }, {
        target: _states.idle
      }]
    },
    states: {
      [_states.idle]: {},
      [_states.retry]: {
        on: {
          [_actions.FETCH]: {
            /* 
              Transition to debouncing state. This
              prevents error & loading view from 
              displaying simultaneously.
            */
            target: _states.debouncing
          }
        }
      },
      [_states.debouncing]: {
        after: [{
          delay: 'backoff',
          target: _states.pending,
          cond: 'shouldRetry',
          actions: 'willRetry'
        }]
      },
      [_states.success]: {},
      [_states.error]: {
        always: [{
          target: _states.retry,
          cond: 'shouldRetry'
        }, {
          target: _states.done
        }]
      },
      [_states.done]: {},
      [_states.pending]: {
        invoke: {
          id: 'getAvailability',
          src: 'getAvailability',
          onDone: {
            actions: 'setAvailByLocId',
            target: _states.success
          },
          onError: _states.error
        }
      }
    }
  };
};
exports.machineJSON = machineJSON;
const createAvailabilityMachine = _ref3 => {
  let {
    customerCode,
    canBookOnline,
    locations,
    provider
  } = _ref3;
  return (0, _xstate.Machine)(machineJSON({
    customerCode,
    canBookOnline,
    locations,
    provider
  }), {
    actions,
    delays,
    guards,
    services
  });
};
var _default = exports.default = createAvailabilityMachine;